// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__J_QM_","title":"style_title__ikf9K","buttonContainer":"style_buttonContainer__LKkci","button":"style_button___4e2V"};